import { Input } from "@/components/ui/input";

interface InlineEventInputProps {
  title: string;
  date: string;
  onTitleChange: (value: string) => void;
  onDateChange: (value: string) => void;
}

export function InlineEventInput({
  title,
  date,
  onTitleChange,
  onDateChange,
}: InlineEventInputProps) {
  return (
    <div className="flex items-center gap-2">
      <Input
        value={title}
        onChange={(e) => onTitleChange(e.target.value)}
        placeholder="Event title"
        className="h-7 text-xs flex-1"
      />
      <Input
        type="date"
        value={date}
        onChange={(e) => onDateChange(e.target.value)}
        className="h-7 text-xs w-40"
      />
    </div>
  );
}
